const DIACRITICS_PATTERN = /\p{Diacritic}/gu;

const normalize = (value) =>
  (value || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(DIACRITICS_PATTERN, '');

export function fuzzyMatchTitle(title, query) {
  const tokens = normalize(query).split(/\s+/).filter(Boolean);
  if (tokens.length === 0) return true;
  const normalizedTitle = normalize(title);
  return tokens.every((token) => normalizedTitle.includes(token));
}
